import React, { Fragment } from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { getOrderStatusColor, getOrderStatusTitle } from "utils"
import classes from "./OfflineOrderDetailsCustomerInfo.module.scss"

const OfflineOrderDetailsCustomerInfo = props => {
  const { offlineOrder } = props

  const [t, i18n] = useTranslation()

  const title = getOrderStatusTitle(offlineOrder, t)

  const color = getOrderStatusColor(offlineOrder)

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <div className={classes["status-container"]}>
        <span>{t("وضعیت")}:</span>

        <div className={classes["status"]}>
          <b
            style={{ backgroundColor: color }}
            className={clsx(
              classes["progress"],
              isLtr && classes["progress-ltr"]
            )}
          >
            {t(title)}
          </b>
        </div>
      </div>
    </Fragment>
  )
}

export default OfflineOrderDetailsCustomerInfo